/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `Band` - Band
 * * `Solo Artist` - Solo Artist
 * * `DJ` - DJ
 * * `Ensemble` - Ensemble
 * * `Orchestra` - Orchestra
 * * `Choir` - Choir
 * * `Comedy` - Comedy
 * * `Theater` - Theater
 * * `Dance` - Dance
 * * `Other` - Other
 * @export
 */
export const PrimaryCategoryEnum = {
    Band: 'Band',
    SoloArtist: 'Solo Artist',
    Dj: 'DJ',
    Ensemble: 'Ensemble',
    Orchestra: 'Orchestra',
    Choir: 'Choir',
    Comedy: 'Comedy',
    Theater: 'Theater',
    Dance: 'Dance',
    Other: 'Other'
} as const;
export type PrimaryCategoryEnum = typeof PrimaryCategoryEnum[keyof typeof PrimaryCategoryEnum];


export function instanceOfPrimaryCategoryEnum(value: any): boolean {
    for (const key in PrimaryCategoryEnum) {
        if (Object.prototype.hasOwnProperty.call(PrimaryCategoryEnum, key)) {
            if (PrimaryCategoryEnum[key as keyof typeof PrimaryCategoryEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PrimaryCategoryEnumFromJSON(json: any): PrimaryCategoryEnum {
    return PrimaryCategoryEnumFromJSONTyped(json, false);
}

export function PrimaryCategoryEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrimaryCategoryEnum {
    return json as PrimaryCategoryEnum;
}

export function PrimaryCategoryEnumToJSON(value?: PrimaryCategoryEnum | null): any {
    return value as any;
}

export function PrimaryCategoryEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): PrimaryCategoryEnum {
    return value as PrimaryCategoryEnum;
}

